import { computed, ComputedRef } from 'vue'
import { useStore } from 'vuex'

import { ChallengeLargeClassification } from '@/domain/entities/problem/challengeLargeClassification'
import { ChallengeMiddleClassification } from '@/domain/entities/problem/challengeMiddleClassification'
import { Contest } from '@/domain/entities/problem/contest'
import { DisplayLanguageType } from '@/domain/value_objects/language/displayLanguageType'
import { ChallengeModuleName } from '@/store/modules/modules'

export class ChallengeViewModel {
  private store = useStore()

  largeClassificationList: ComputedRef<{ [id: string]: ChallengeLargeClassification }> = computed(
    () => this.store.getters[`${ChallengeModuleName}/largeClassificationList`]
  )

  middleClassificationList: ComputedRef<{ [largeClassificationId: string]: ChallengeMiddleClassification[] }> =
    computed(() => this.store.getters[`${ChallengeModuleName}/middleClassificationList`])

  contestList: ComputedRef<{ [largeClassificationId: string]: { [middleClassificationId: string]: Contest[] } }> =
    computed(() => this.store.getters[`${ChallengeModuleName}/contestList`])

  isLoading: ComputedRef<boolean> = computed(() => this.store.getters[`${ChallengeModuleName}/isLoading`])

  error: ComputedRef<string | null> = computed(() => this.store.getters[`${ChallengeModuleName}/error`])

  async getChallengeList(displayLanguage: DisplayLanguageType): Promise<void> {
    await this.store.dispatch(`${ChallengeModuleName}/getChallengeList`, { displayLanguage })
  }

  async getChallengeById(
    displayLanguage: DisplayLanguageType,
    challengeLargeClassificationId: string,
    challengeMiddleClassificationId: string
  ): Promise<void> {
    await this.store.dispatch(`${ChallengeModuleName}/getChallengeById`, {
      displayLanguage,
      challengeLargeClassificationId,
      challengeMiddleClassificationId
    })
  }
}
